import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { OrderDetailComponent } from '../order-detail/order-detail.component';
import { OrderOutputDto, OrderService } from 'src/generated_client';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-completed-orders',
  templateUrl: './completed-orders.component.html',
  styleUrls: ['./completed-orders.component.css']
})
export class CompletedOrdersComponent implements OnInit {

  displayedColumns: string[] = ['codigo', 'tienda', 'usuario', 'direccion', 'items', 'total', 'estado', 'opciones'];
  allCompleted: OrderOutputDto[] = [];

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private orderService: OrderService,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.orderService.apiOrderGetAllTravellingGet().subscribe(x => {
      this.allCompleted = x;
      this.allCompleted.sort((a, b) => (a.dtUpdatedAt! > b.dtUpdatedAt!) ? 1 : -1);
    })
  }


  open(id: number) {
    let order = this.allCompleted.find(x => x.cdOrder);
    let items = order?.itemInOrderOutputDtos;
    this.dialog.open(OrderDetailComponent, {
      data: {
        items: items,
        delivery: order?.qtDCharges,
        discount: order?.qtDiscount,
        total: order?.qtTotal,
        notes: order?.dsNotes
      }
    });
  }

  confirmDeliver(id: number) {
    this.orderService.apiOrderConfirmDeliverPut(id).subscribe(response => {
      this.snackBar.openSnackBar("La entrega fue confirmada", 'Aceptar');
      this.router.navigate(['completed-orders']);
    }, err => {
      this.snackBar.openSnackBar("No se pudo confirmar la entrega", 'Aceptar');
    });
  }

  printOrder() {
    this.router.navigate(['order-receipt']);
  }


}








